import FillBlanks from "../../components/ClassOne/EnvironmentScience/MyAir/FillBlanks";
import TrueFalse from "../../components/ClassOne/EnvironmentScience/MyAir/TrueFalse";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/environmental-science/my-need-air/fill-blanks", title: "Fill in the Blanks", component: FillBlanks },
    { url: "/class-one/environmental-science/my-need-air/true-false", title: "True or False", component: TrueFalse },
];

export default topics;